import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { ListingCard, PaginationLinks } from '../../components';
import css from './SearchResultsPanel.css';
import { FormattedMessage } from '../../util/reactIntl';

import { groupedByCoordinates, reducedToArray } from '../SearchMap/SearchMap.helpers.js';
// bringing in seo stuff
import { StaticPage } from '../../containers';
import Cookies from 'universal-cookie';
import Cards from './Cards';

const cookies = new Cookies();

const SearchResultsPanel = props => {
  const {
    className,
    rootClassName,
    listings,
    pagination,
    search,
    setActiveListing,
    listingsAreLoaded,
    resultsCount,
    sortByComponent,
    searchInProgress,
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  const hasNoResult = listingsAreLoaded && resultsCount === 0;

  const paginationLinks =
    pagination && pagination.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName="SearchPage"
        pageSearchParams={search}
        pagination={pagination}
      />
    ) : null;

  // Panel width relative to the viewport
  const panelMediumWidth = 50;
  const panelLargeWidth = 62.5;
  const cardRenderSizes = [
    '(max-width: 767px) 100vw',
    `(max-width: 1023px) ${panelMediumWidth}vw`,
    `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
    `${panelLargeWidth / 3}vw`,
  ].join(', ');

  const listingArraysInLocations = reducedToArray(groupedByCoordinates(listings));

  // console.log('sortByComponentKeys', Object.keys(sortByComponent));
  // console.log('sortByComponent', sortByComponent);
  // console.log('sortByComponentPropsSort', sortByComponent.props.sort);

  return (
    <StaticPage
      title={
        cookies.get('language') === 'en'
          ? 'socialbnb - book sustainable accommodations worldwide. '
          : 'socialbnb - Buche nachhaltige Unterkünfte weltweit.'
      }
      keywords={
        cookies.get('language') === 'en'
          ? 'Accommodation, accommodation worldwide, special accommodation, sustainable accommodation, unique accommodation, accommodation that does something good'
          : 'Unterkunft, Unterkünfte weltweit, besondere Unterkünfte, nachhaltige Unterkünfte, einzigartige Unterkünfte, Unterkünfte die etwas Gutes tun'
      }
      description={
        cookies.get('language') === 'en'
          ? 'Book unique, sustainable accomodations worldwide. Support an ecological and social project with your booking.'
          : 'Buche einzigartige, nachhaltige Unterkünfte weltweit. Mit deiner Übernachtung unterstützt du ein ökologisches oder soziales Projekt.'
      }
      schema={{
        '@context': 'http://schema.org',
        '@type': 'Organisation',
        name: 'TouristDestination'
      }}

    >
      <div className={classes}>
        <div className={css.searchOptions}>
          {searchInProgress ? (
            <div className={css.searchResultSummary}>
              <div className={css.resultsFound}>
                <FormattedMessage id="SearchFiltersPrimary.loadingResults" />
              </div>
            </div>
          ) : null}
          {listingsAreLoaded ? (
            <div className={css.searchResultSummary}>
              <span className={css.resultsFound}>
                <FormattedMessage
                  id="SearchFiltersPrimary.foundResults"
                  values={{ count: resultsCount }}
                />
              </span>
            </div>
          ) : null}
          {sortByComponent}
        </div>
        {hasNoResult ? (
          <div className={css.noSearchResults}>
            <FormattedMessage id="SearchFiltersPrimary.noResults" />
          </div>
        ) : null}
        <div className={css.listingCards}>
          {/* if lowest or highest price is selected, do not reverse the listings because its sorting wrong way */}
          {/* Check the console.logs above for the details of sortByComponent */}
          {sortByComponent.props.sort === '-price' || sortByComponent.props.sort === 'price'
            ? listingArraysInLocations.map((l, index) => (
              <div key={index}>
                {l.length === 1 ? (
                  <ListingCard
                    className={css.listingCard}
                    key={l[0].id.uuid}
                    listing={l[0]}
                    renderSizes={cardRenderSizes}
                    setActiveListing={setActiveListing}
                  />
                ) : (
                  <Cards array={l} setActiveListing={setActiveListing} />
                )}
              </div>
            ))
            : listingArraysInLocations
              .map((l, index) => (
                <div key={index}>
                  {l.length === 1 ? (
                    <ListingCard
                      className={css.listingCard}
                      key={l[0].id.uuid}
                      listing={l[0]}
                      renderSizes={cardRenderSizes}
                      setActiveListing={setActiveListing}
                    />
                  ) : (
                    <Cards array={l} setActiveListing={setActiveListing} />
                  )}
                </div>
              ))}
          {props.children}
        </div>
        {paginationLinks}
      </div>
    </StaticPage>
  );
};

SearchResultsPanel.defaultProps = {
  children: null,
  className: null,
  listings: [],
  pagination: null,
  rootClassName: null,
  search: null,
};

const { array, node, object, string } = PropTypes;

SearchResultsPanel.propTypes = {
  children: node,
  className: string,
  listings: array,
  pagination: propTypes.pagination,
  rootClassName: string,
  search: object,
};

export default SearchResultsPanel;
